import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { HpSharedInViewport } from '../HpSharedInViewport/HpSharedInViewport';

class HpSharedCarouselTracking extends Component {
    trackedCarouselPages = new Set();

    trackImpressions(page) {
        if (!this.trackedCarouselPages.has(page)) {
            const { items, onItemsImpression } = this.props;
            const itemsPerPage = Math.floor(this.props.itemsPerPage);
            const startIndex = page * itemsPerPage;
            const visibleItems = items.slice(startIndex, startIndex + itemsPerPage);

            onItemsImpression({
                visibleItems,
                index: startIndex,
            });

            this.trackedCarouselPages.add(page);
        }
    }

    handleInitialDisplay = ({ inViewport }) => {
        if (inViewport) {
            this.props.onInitialDisplay();
            this.trackImpressions(0);
        }
    };

    handleIndexChange = ({ prev, index }) => {
        const itemsPerPage = Math.floor(this.props.itemsPerPage);
        const prevPage = Math.ceil(prev / itemsPerPage);
        const page = Math.ceil(index / itemsPerPage);

        if (page !== prevPage) {
            this.trackImpressions(page);
        }
    };

    handlePageChange = page => {
        this.trackImpressions(page);
    };

    render() {
        return (
            <Fragment>
                <HpSharedInViewport
                    stopWhenInViewport
                    onInViewportChange={this.handleInitialDisplay}
                >
                    {this.props.children({
                        handleIndexChange: this.handleIndexChange,
                        handlePageChange: this.handlePageChange,
                    })}
                </HpSharedInViewport>
            </Fragment>
        );
    }
}

HpSharedCarouselTracking.propTypes = {
    children: PropTypes.func.isRequired,
    onInitialDisplay: PropTypes.func,
    itemsPerPage: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
    onItemsImpression: PropTypes.func,
};

HpSharedCarouselTracking.defaultProps = {
    onInitialDisplay: () => {},
    onItemsImpression: () => {},
};

export { HpSharedCarouselTracking };
